<template>
  <!-- 主容器 (需求1&2) -->
  <div class="w-full h-[18.75vw] relative">
    <!-- 上部分容器 -->
    <div class="w-full h-[15.625vw] bg-[#1E202C]">
      <!-- 优化后的内容容器 -->
      <div class="w-[61.46vw] h-[15.625vw] relative mx-auto overflow-hidden">
        <!-- 左侧联系方式 -->
        <div
          class="w-[24.58vw] left-0 top-[2.92vw] absolute flex flex-col items-start"
        >
          <!-- 公司名称 -->
          <div class="flex items-center gap-[1.25vw]">
            <div
              class="text-right justify-start text-white text-[0.73vw] font-bold font-harmony"
            >
              西安蓝悦教育科技有限公司
            </div>
            <div
              class="text-right justify-start text-[#F28334] text-[0.73vw] font-bold font-harmony"
            >
              科学育人&nbsp;&nbsp;&nbsp;&nbsp;启发开智
            </div>
          </div>

          <!-- 社交媒体区域 -->
          <div class="mt-[2.34vw] flex items-center gap-[0.21vw]">
            <div class="w-[4.01vw] h-[4.01vw] relative mr-[1.04vw]">
              <img class="w-full" src="@/assets/images/Footer/weixin.png" />
            </div>
            <div class="w-[4.01vw] h-[4.01vw] relative">
              <img class="w-full" src="@/assets/images/Footer/douyin.png"/>
            </div>
            <!-- 联系电话 -->
            <div class="ml-[1.04vw]">
              <div
                class="text-left justify-start text-[#FFFFFF] text-[0.73vw] font-bold font-harmony"
              >
                咨询电话(Tel) :
              </div>
              <div
                class="text-right justify-start text-white text-[1.25vw] font-normal font-ddin uppercase"
              >
                400 0336 691
              </div>
            </div>
          </div>

          <!-- 地址信息 -->
          <div
            class="mt-[1.56vw] text-left justify-start text-[#FFFFFFCC] text-[0.68vw] font-normal font-harmony leading-snug"
          >
            西安市沣东新城沣东大道2196号沣东自贸新天地文创街区2C
          </div>
        </div>

        <!-- 右侧链接区域 -->
        <div class="w-[31.41vw] right-0 top-[2.92vw] absolute flex h-full">
          <!-- 友情链接 -->
          <div class="flex flex-col items-start flex-1">
            <div
              class="text-left justify-start text-white text-[0.73vw] font-bold font-harmony"
            >
              友情链接
            </div>
            <div class="mt-[2.34vw] flex flex-col gap-[0.42vw]">
              <div
                v-for="(link, index) in links"
                :key="index"
                class="flex items-center gap-[0.42vw]"
              >
                <a
                  :href="link.url"
                  class="text-center justify-center text-[#FFFFFFCC] text-[0.68vw] font-normal font-harmony"
                >
                  {{ link.name }}
                </a>
              </div>
            </div>
          </div>

          <!-- 名校合作 -->
          <div class="flex flex-col items-start flex-1">
            <div
              class="text-left justify-start text-white text-[0.73vw] font-bold font-harmony"
            >
              名校合作
            </div>
            <div class="mt-[2.34vw] flex flex-col gap-[0.42vw]">
              <div
                v-for="(school, index) in schools"
                :key="index"
                class="flex items-center gap-[0.42vw]"
              >
                <img class="w-[1.25vw] h-[1.25vw]" :src="school.icon" />
                <a
                  :href="school.url"
                  class="text-left justify-start text-[#FFFFFFCC] text-[0.68vw] font-normal font-harmony"
                >
                  {{ school.name }}
                </a>
              </div>
            </div>
          </div>

          <!-- 赛证合作 -->
          <div class="flex flex-col items-start flex-1">
            <div
              class="text-left justify-start text-white text-[0.73vw] font-bold font-harmony"
            >
              赛证合作单位
            </div>
            <div class="mt-[2.34vw] flex flex-col gap-[0.42vw]">
              <div
                v-for="(org, index) in organizations"
                :key="index"
                class="flex items-center gap-[0.42vw]"
              >
                <img class="w-[1.25vw] h-[1.25vw]" :src="org.icon" />
                <a
                  :href="org.url"
                  class="text-left justify-start text-[#FFFFFFCC] text-[0.68vw] font-normal font-harmony"
                >
                  {{ org.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- 分割线 -->
        <div
          class="w-[61.46vw] h-[0.05vw] absolute top-[5vw] bg-[#313131]"
        ></div>
      </div>
    </div>

    <!-- 下部分版权信息 (需求3) -->
    <div class="w-full h-[3.125vw] bg-[#171925] flex items-center">
      <div class="w-[61.46vw] mx-auto flex justify-between items-center">
        <div
          class="text-right justify-start text-[#FFFFFFA6] text-sm font-normal font-harmony"
        >
          西安蓝悦教育科技有限公司 版权所有
        </div>
        <div
          class="text-right justify-start text-[#FFFFFFA6] text-xs font-normal font-harmony"
        >
        陕ICP备2025064734号-2
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { name: "蓝悦官网", url: "https://www.lanyve.com" },
        { name: "其他链接", url: "https://www.bing.com" },
      ],
      schools: [
        {
          name: "陕西师范大学",
          icon: require("@/assets/images/Footer/sxsfdx.png"),
          url: "https://www.snnu.edu.cn",
        },
        {
          name: "西安交通大学",
          icon: require("@/assets/images/Footer/xajtdx.png"),
          url: "https://www.xjtu.edu.cn",
        },
        {
          name: "西北工业大学",
          icon: require("@/assets/images/Footer/xbgydx.png"),
          url: "https://www.nwpu.edu.cn",
        },
      ],
      organizations: [
        {
          name: "中国航空运动协会",
          icon: require("@/assets/images/Footer/zghkxh.png"),
          url: "https://www.asfc.org.cn",
        },
        {
          name: "中国民航局",
          icon: require("@/assets/images/Footer/zgmhj.png"),
          url: "http://www.caac.gov.cn",
        },
        {
          name: "中国航空学会",
          icon: require("@/assets/images/Footer/zghkxh.png"),
          url: "http://www.csaa.org.cn",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* 页脚样式 */
</style>